export const formatCount = (v: number) => Math.round(v).toLocaleString('en-GB');
export const formatPercent = (v: number) => `${v.toFixed(2)}%`;
export const formatMs = (v: number) => `${Math.round(v)} ms`;
export const orDash = (v: number | null, format: (v: number) => string) => (v == null ? '—' : format(v));

export function timeAgo(date: Date, now: number) {
    const s = Math.max(0, Math.round((now - date.getTime()) / 1000));
    if (s < 60) return `${s}s ago`;
    if (s < 3600) return `${Math.floor(s / 60)}m ago`;
    if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
    return `${Math.floor(s / 86400)}d ago`;
}
